export enum EAccessLevel {
  ADMIN = "ADMIN",
  OPERATE = "OPERATE",
  VIEW = "VIEW",
  VIEW_REDACTED = "VIEW_REDACTED",
  // Not an API value: the UI's stand-in for a user with no grants.
  NO_ACCESS = "NO_ACCESS",
}
